import comp from "./AssessmentSubjectStandards";
export default comp;
